import { render, staticRenderFns } from "./Teleport.vue?vue&type=template&id=286bc42e&scoped=true&"
import script from "./Teleport.vue?vue&type=script&lang=js&"
export * from "./Teleport.vue?vue&type=script&lang=js&"
import style0 from "./Teleport.vue?vue&type=style&index=0&id=286bc42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bc42e",
  null
  
)

export default component.exports